import merge from 'lodash.merge';
import { MouseEvent } from 'react';

// convert dot notation string to nested object
export const createNestedObject = (fields: string, value: any): object => {
    const fieldsArr = fields.split('.');
    const reducer = (accum, item, index, array) => ({ [item]: index + 1 < array.length ? accum : value });
    return fieldsArr.reduceRight(reducer, {});
};

/**
 * Convert errors to the supported shape by final-form
 * e.g. { 'field.nestedField': 'error message' } => { field: { nestedField : 'error message' } }
 */
export const convertErrors = (errors: object | undefined) => {
    if (!errors) return;

    const result = {};
    for (const [key, value] of Object.entries(errors)) {
        merge(result, createNestedObject(key, value));
    }

    return result;
};

/**
 * Forces the blur event on active field before submitting the form to ensure that all fields are updated and validated.
 * This is necessary because final-form does not trigger the blur event if you press Enter to submit the form.
 * The refocus on active element is to return to the original input field in case of validation error, so that the user's flow is not interrupted.
 */
export const blurFieldsBeforeSubmit = ({ target }: MouseEvent['nativeEvent']) => {
    const element = document.activeElement as HTMLElement | null;
    if (target instanceof HTMLButtonElement && target.type === 'submit') {
        target.focus();
        element?.focus();
    }
};
